import request from '@/utils/requestTeacher'

export function login(data) {
  return request({
    url: '/teacher/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/teacher/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/teacher/info',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/teacher/update/password',
    method: 'post',
    data
  })
}

export function saveUserSetting(data) {
  return request({
    url: '/teacher/setting/save',
    method: 'post',
    data
  })
}

export function getUserSetting(data) {
  return request({
    url: '/teacher/setting/data',
    method: 'post',
    data
  })
}

export function getLeaveList(data) {
  return request({
    url: '/teacher/leave/list',
    method: 'post',
    data
  })
}

export function auditLeave(data) {
  return request({
    url: '/teacher/leave/audit',
    method: 'post',
    data
  })
}

export function deleteLeave(data) {
  return request({
    url: '/teacher/leave/delete',
    method: 'post',
    data
  })
}

export function getTeacherData(data) {
  return request({
    url: '/teacher/total/data',
    method: 'post',
    data
  })
}

export function ShowNoticeCourse(data) {
  return request({
    url: '/teacher/shownoticecourse',
    method: 'post',
    data
  })
}

export function IsReadNotice(data) {
  return request({
    url: '/teacher/isreadnotice',
    method: 'post',
    data
  })
}

export function getTeacherClassTimesList(data) {
  return request({
    url: '/teacher/class/time/list',
    method: 'post',
    data
  })
}

export function joinOnlineRoom(data) {
  return request({
    url: '/teacher/join/online/room',
    method: 'post',
    data
  })
}

export function getRoomRecordList(data) {
  return request({
    url: '/teacher/room/record/list',
    method: 'post',
    data
  })
}

export function getClassTotalList(data) {
  return request({
    url: '/teacher/class/total/list',
    method: 'post',
    data
  })
}

export function getClassCallList(data) {
  return request({
    url: '/teacher/class/call/list',
    method: 'post',
    data
  })
}

export function saveClassCallData(data) {
  return request({
    url: '/teacher/class/call/update',
    method: 'post',
    data
  })
}

export function getClassCallStudentList(data) {
  return request({
    url: '/teacher/class/call/students',
    method: 'post',
    data
  })
}

export function getDayTotal(data) {
  return request({
    url: '/teacher/day/class/total',
    method: 'post',
    data
  })
}

export function getClassWorkList(data) {
  return request({
    url: '/teacher/class/work/list',
    method: 'post',
    data
  })
}

export function deleteClassWork(data) {
  return request({
    url: '/teacher/class/work/delete',
    method: 'post',
    data
  })
}

export function saveClassWork(data) {
  return request({
    url: '/teacher/class/work/save',
    method: 'post',
    data
  })
}

export function getWorkClassTimeList(data) {
  return request({
    url: '/teacher/class/work/time/list',
    method: 'post',
    data
  })
}

export function updateClassWork(data) {
  return request({
    url: '/teacher/class/work/update',
    method: 'post',
    data
  })
}

export function editClassWork(data) {
  return request({
    url: '/teacher/class/work/edit',
    method: 'post',
    data
  })
}

export function TaskInfo(data) {
  return request({
    url: '/teacher/class/work/info',
    method: 'post',
    data
  })
}

export function StudentTaskList(data) {
  return request({
    url: '/teacher/class/work/student/list',
    method: 'post',
    data
  })
}

export function studentWorkInfo(data) {
  return request({
    url: '/teacher/class/work/student/info',
    method: 'post',
    data
  })
}

export function saveWorkComment(data) {
  return request({
    url: '/teacher/class/work/student/remark',
    method: 'post',
    data
  })
}

export function saveTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/save',
    method: 'post',
    data
  })
}

export function getTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/list',
    method: 'post',
    data
  })
}

export function deleteTeacherClassTime(data) {
  return request({
    url: 'admin/teacher/class/time/delete',
    method: 'post',
    data
  })
}

export function cancelReservation(data) {
  return request({
    url: 'admin/teacher/class/time/cancel',
    method: 'post',
    data
  })
}

export function getTeacherRulesList(data) {
  return request({
    url: 'admin/teacher/rules/list',
    method: 'post',
    data
  })
}

export function getTeacherRulesDetail(data) {
  return request({
    url: 'admin/teacher/rules/detail',
    method: 'post',
    data
  })
}

export function getTeacherRulesColumns(data) {
  return request({
    url: 'admin/teacher/rules/columns',
    method: 'post',
    data
  })
}

export function getAmountTotalList(data) {
  return request({
    url: 'teacher/hours/amount/total',
    method: 'post',
    data
  })
}

export function getClassTimeComment(data) {
  return request({
    url: 'teacher/class/time/comment',
    method: 'post',
    data
  })
}

export function getClassTimeMaterial(data) {
  return request({
    url: 'teacher/class/time/material',
    method: 'post',
    data
  })
}

export function getClassTimeFeedback(data) {
  return request({
    url: 'teacher/class/time/feedback/info',
    method: 'post',
    data
  })
}

export function saveClassTimeFeedback(data) {
  return request({
    url: 'teacher/class/time/feedback/save',
    method: 'post',
    data
  })
}

export function saveClassTimeCancel(data) {
  return request({
    url: 'teacher/class/time/cancel/save',
    method: 'post',
    data
  })
}

export function getClassTimeCancelInit(data) {
  return request({
    url: 'teacher/cancel/class/time/init',
    method: 'post',
    data
  })
}

export function classTimeSignIn(data) {
  return request({
    url: 'teacher/class/time/sign/in',
    method: 'post',
    data
  })
}

export function saveClassTimeHelp(data) {
  return request({
    url: 'teacher/class/time/help/save',
    method: 'post',
    data
  })
}

export function getTeacherHomeData(data) {
  return request({
    url: 'teacher/user/home/data',
    method: 'post',
    data
  })
}

export function getTeacherInfoData(data) {
  return request({
    url: 'teacher/get/info/data',
    method: 'post',
    data
  })
}

export function saveTeacherInfo(data) {
  return request({
    url: 'teacher/edit/info/save',
    method: 'post',
    data
  })
}

export function getReviewDisplay(data) {
  return request({
    url: 'teacher/review/display/list',
    method: 'post',
    data
  })
}

export function getTeacherPointLevelList(data) {
  return request({
    url: 'teacher/points/level/list',
    method: 'post',
    data
  })
}

export function getTeacherPointList(data) {
  return request({
    url: 'teacher/points/list',
    method: 'post',
    data
  })
}

export function getTeacherFeedbackList(data) {
  return request({
    url: 'teacher/feedback/list',
    method: 'post',
    data
  })
}

export function saveTeacherFeedback(data) {
  return request({
    url: 'teacher/feedback/save',
    method: 'post',
    data
  })
}

export function getTeacherFeedback(data) {
  return request({
    url: 'teacher/feedback/detail',
    method: 'post',
    data
  })
}

export function saveTeacherFeedbackReply(data) {
  return request({
    url: 'teacher/feedback/reply/save',
    method: 'post',
    data
  })
}

export function getTeacherSuggestion(data) {
  return request({
    url: 'teacher/suggestion/list',
    method: 'post',
    data
  })
}

export function saveTeacherContractAgree(data) {
  return request({
    url: 'teacher/contract/agree/save',
    method: 'post',
    data
  })
}

export function getTeacherContractUrl(data) {
  return request({
    url: 'teacher/contract/url',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/teacher/index.js